<template>
	<div class="chronicle-view">
		<Tabs :tabs="chronicleTabs" class="chronicle-view__tabs">
			<template v-slot:tab1>
				<div class="chronicle-view__main">
					<span class="chronicle-view__heading">
						{{ translate("ui.replay_story") }}
					</span>
					<div class="replay-list">
						<QuestStoryReplayBox
							v-for="(quest, index) in chroniclesData"
							:key="index"
							:heading="quest.heading"
							:type="`main-chronicle-${index}`"
							:quest="quest?.quest"
							:id="quest.id"
							@play="onPlay"
						/>
					</div>
				</div>
			</template>
		</Tabs>
	</div>
</template>

<script lang="ts" setup>
import QuestStoryReplayBox from "@/components/Quests/QuestStoryReplayBox.vue";
import Tabs from "@/components/Tabs.vue";
import type { QuestActive } from "@/types/quest";
import { translate } from "@/utils/translate";

type ChronicleData = {
	id: number;
	quest?: QuestActive;
	heading: string;
};

defineProps<{
	chroniclesData: ChronicleData[];
	onPlay: (id?: number, isStory?: boolean) => void;
}>();

const chronicleTabs = [{ name: "ui.main_quests" }];
</script>

<style lang="scss" scoped>
.chronicle-view {
	width: 100%;
	height: 100%;

	&__main,
	&__side {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		width: 100%;
		max-height: 24rem;
	}

	&__heading {
		margin-bottom: 1rem;
		color: #f4d278;
		font-weight: 800;
		font-size: 0.875rem;
		text-align: center;
		text-shadow: 0.044rem 0.044rem 0.063rem rgba(0, 0, 0, 0.6);
	}

	.replay-list {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 0.5rem;
		padding-bottom: 0.125rem;
		width: 100%;
	}
}

:deep(.chronicle-view__tabs .tabs__content .chronicle-view__main),
:deep(.chronicle-view__tabs .tabs__content .chronicle-view__side) {
	padding: 0 1rem;
}
</style>
